import React from 'react';
import DialForm from './DialForm';

const CreateDial = () => {
    return (
        <div>
            <DialForm mode="create" />
        </div>
    );
};

export default CreateDial;